import React, { useState } from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import Checkbox from "@mui/material/Checkbox";
import ListItemText from "@mui/material/ListItemText";
import ListItem from "@mui/material/ListItem";

const CountrySelect = ({ countries, required }) => {
  const [selectedCountries, setSelectedCountries] = useState([]);
  const [error, setError] = useState(false);

  const handleCountryChange = (event, value) => {
    setSelectedCountries(value);
    setError(required && (!value || value.length === 0));
  };

  const handleSelectAll = () => {
    if (selectedCountries.length === countries.length) {
      setSelectedCountries([]);
    } else {
      setSelectedCountries(countries);
    }
    setError(required && (!selectedCountries || selectedCountries.length === 0));
  };

  return (
    <Box
      sx={{
        "& .MuiTextField-root": { m: 1, width: 300 },
      }}
    >
      <div>
        <Autocomplete
          multiple
          id="country-select-demo"
          sx={{ width: 300 }}
          options={[{ label: "Select All", group: "Select All" }, ...countries]}
          groupBy={(option) => option.group}
          autoHighlight
          getOptionLabel={(option) => option.label}
          onChange={handleCountryChange}
          value={selectedCountries}
          renderOption={(props, option) => {
            if (option && option.group === "Select All") {
              return (
                <ListItem
                  {...props}
                  style={{
                    justifyContent: "flex-start",
                    margin: "0px",
                    padding: "0px",
                  }}
                >
                  <Checkbox
                    color="primary"
                    onChange={handleSelectAll}
                    checked={selectedCountries.length === countries.length}
                  />
                  &nbsp;&nbsp;
                  <ListItemText primary="Select All" />
                </ListItem>
              );
            }
            return (
              <ListItem
                {...props}
                style={{
                  justifyContent: "flex-start",
                  margin: "0px",
                  padding: "0px",
                }}
              >
                <Checkbox
                  color="primary"
                  checked={selectedCountries.some(
                    (country) => country.code === option.code
                  )}
                />
                <div style={{ display: "flex", alignItems: "center" }}>
                  <ListItemText
                    primary={option.label}
                    secondary={`(${option.code}) +${option.phone}`}
                    sx={{ marginLeft: "10px" }} // Adding space to the right of the text
                  />
                  <img
                    loading="lazy"
                    width="20"
                    srcSet={`https://flagcdn.com/w40/${option.code.toLowerCase()}.png 2x`}
                    src={`https://flagcdn.com/w20/${option.code.toLowerCase()}.png`}
                    alt=""
                    style={{ marginLeft: "180px" }} // Adding space to the right of the image
                  />
                </div>
              </ListItem>
            );
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label={`Choose A Country${required ? " *" : ""}`}
              inputProps={{
                ...params.inputProps,
                autoComplete: "new-password", // disable autocomplete and autofill
              }}
              error={required && error}
              helperText={required && error ? "Please select a country" : null}
              style={{ height: "56px" }}
            />
          )}
        />
      </div>
    </Box>
  );
};

export default CountrySelect;
